<template>
  <div class="car-item car-region" v-if="selectedRegion.formattedName">
    <span class="car-icon"></span>
    <span class="car-text">
      {{selectedRegion.formattedName}}
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'SelectedRegionTile',
  computed: {
    ...mapGetters('region', {
      selectedRegion: 'selectedRegion'
    })
  }
}
</script>
